<template>
  <div class="modal warning fade" :class="{'is-open': open}">
    <div class="modal-dialog modal-sm">
      <div class="modal-content">
        <div class="modal-body">
          <div class="warning d-flex">
            <img
              width="48"
              :src="`${BaseUrl}assets/common/warning.png`"
              :srcset="`${BaseUrl}assets/common/warning@2x.png`"
            />
            <content>
              <slot name="content"></slot>
            </content>
          </div>
          <div class="action text-right">
            <a @click="$emit('add-other-sub-contract')" class="btn btn-default" type="button" role="button">新增附約</a>
            <a @click="$emit('add-other-contract')" class="btn btn-default" type="button" role="button">新增其他主約</a>
            <a @click="$emit('finished')" class="btn btn-primary" type="button" role="button">完成</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "bkGoOnAddOtherCompContract",
  computed: {
    ...mapGetters(["BaseUrl"]),
  },
  props: {
    open: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
